import { render, staticRenderFns } from "./PowerIcon.vue?vue&type=template&id=5fcd7004&"
import script from "./PowerIcon.vue?vue&type=script&lang=ts&"
export * from "./PowerIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports